import type { FC, ReactElement } from "react"

import { THEME } from "@/3514/theme"
import { buildCssClassName } from "@/3514/utils"

type TProps = { width?: number; height?: number; className?: string; fillColor?: string }

const Icon: FC<TProps> = ({
    width = 18,
    height = 18,
    className = String(),
    fillColor = THEME.COLORS.gray[23]
}: TProps): ReactElement => (
    <svg
        className={buildCssClassName({ [className]: className })}
        width={width}
        height={height}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.0625 9.1125L7.64062 11.8125L13.5 6.1875"
            stroke={fillColor}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

Icon.displayName = "CheckMarkIcon"

export { Icon as CheckMarkIcon }
